var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
define(["require", "exports", "backbone", "jquery", "i18n/i18n"], function (require, exports, backbone_1, jquery_1, i18n_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ModalDialogView = void 0;
    backbone_1 = __importDefault(backbone_1);
    jquery_1 = __importDefault(jquery_1);
    i18n_1 = __importDefault(i18n_1);
    const customModalTemplate = () => `
<div data-keyboard="false" data-backdrop="static" class="modal mb-upload-modal" tabindex="-1" role="dialog">
 <div class="modal-dialog modal-dialog-top modal-lg">
  <div class="modal-content">
     <div class="modal-header">
     </div>
     <div class="modal-body">
     </div>
     <div class="modal-footer hidden">
      <button class="btn btn-default cancel-modal" data-dismiss="modal">${(0, i18n_1.default)("Cancel")}</button>
      <button disabled class="btn btn-default apply-modal" data-dismiss="modal">${(0, i18n_1.default)("Apply")}</button>
    </div>
  </div>
</div>`;
    class ModalDialogView extends backbone_1.default.View {
        constructor(options) {
            super(options);
            this.initialize();
        }
        initialize() {
            this.events = {
                "click .apply-modal": "applyModal",
                "click *.close, *.cancel-modal": "cancelModal"
            };
            this.el.innerHTML = customModalTemplate();
            this.dialogEl = this.el.querySelector(".modal");
            this.headerEl = this.el.querySelector(".modal-header");
            this.bodyEl = this.el.querySelector(".modal-body");
            this.applyButtonEl = this.el.querySelector(".apply-modal");
            this.title = "";
            this._onKeyDown = this._onKeyDown.bind(this);
            document.addEventListener("keydown", this._onKeyDown);
        }
        _onKeyDown(e) {
            if (e.key === "Escape") {
                this.cancelModal();
            }
        }
        remove() {
            document.removeEventListener("keydown", this._onKeyDown);
            return super.remove();
        }
        setView(view) {
            var _a, _b;
            if (this.view === view) {
                return;
            }
            if (this.view) {
                if (this.view.close) {
                    this.view.close(true);
                }
                this.stopListening(this.view);
                (_b = (_a = this.view).destroy) === null || _b === void 0 ? void 0 : _b.call(_a);
            }
            if (view.getTitle) {
                this.title = view.getTitle();
            }
            this.view = view;
            this.listenTo(this.view, "validate", this.validate);
            if (this.view.isValid) {
                this.validate(this.view.isValid());
            }
            this.bodyEl.innerHTML = "";
            this.bodyEl.appendChild(this.view.el);
            this.render();
        }
        render() {
            this.headerEl.innerHTML = `<h3 class='modal-title'>${this.title}</h3>
        <button type="button" class="close" data-dismiss="modal">✕</button>`;
            if (this.view) {
                this.view.render();
            }
            return this;
        }
        validate(result) {
            if (result) {
                this.applyButtonEl.removeAttribute("disabled");
            }
            else {
                this.applyButtonEl.setAttribute("disabled", "");
            }
        }
        show() {
            (0, jquery_1.default)(this.dialogEl).modal("show");
        }
        applyModal() {
            if (this.view) {
                if (this.view.close) {
                    this.view.close(false);
                }
                this.view.remove();
            }
            this.remove();
        }
        cancelModal() {
            if (this.view) {
                if (this.view.close) {
                    this.view.close();
                }
                this.view.remove();
            }
            this.remove();
        }
    }
    exports.ModalDialogView = ModalDialogView;
});
